<template>
  <div class="mt-2.5">
    <div class="mb-2.5 flex items-center text-sm font-medium text-gray-700">
      {{ t("common.fileUploadEditor.fileTypes") }}
    </div>
    <UICheckboxGroup
      :value="options"
      class="flex items-center space-x-2 text-sm"
      :disabled="false"
      @update:value="handleUpdate"
    >
      <UICheckbox id="all" class="w-1/4" value="all" :label="t('common.fileUploadEditor.all')" />
      <UICheckbox id="pdf" class="w-1/4" value=".pdf" :label="t('common.fileUploadEditor.pdf')" />
      <UICheckbox
        id="doc"
        class="w-1/2"
        value=".doc"
        :label="t('common.fileUploadEditor.docxDoc')"
      />
      <UICheckbox id="png" class="w-1/4" value=".png" :label="t('common.fileUploadEditor.png')" />
      <UICheckbox id="gif" class="w-1/4" value=".gif" :label="t('common.fileUploadEditor.gif')" />
      <UICheckbox
        id="jpg"
        class="w-1/2"
        value=".jpg"
        :label="t('common.fileUploadEditor.jpgJpeg')"
      />
      <UICheckbox
        id="xls"
        class="w-1/2"
        value=".xls"
        :label="t('common.fileUploadEditor.xlsCsv')"
      />
    </UICheckboxGroup>
  </div>
</template>

<script setup lang="ts">
import { UICheckbox, UICheckboxGroup } from "@gohighlevel/ghl-ui";
import { ref, type PropType } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  options: {
    type: Array as PropType<string[]>,
    default: null,
  },
});

const emit = defineEmits(["update:options"]);

const options = ref(props.options?.length ? props.options : ["all"]);

const handleUpdate = (newValue) => {
  if (newValue[newValue?.length - 1] === "all") {
    options.value = ["all"];
  } else if (newValue.includes("all") && newValue?.length > 1) {
    options.value = newValue.filter((option) => option !== "all");
  } else {
    const acceptedFormat = [...newValue];

    if (acceptedFormat.includes(".jpg")) {
      !acceptedFormat.includes(".jpeg") ? acceptedFormat.push(".jpeg") : null;
    } else {
      acceptedFormat.includes(".jpeg")
        ? acceptedFormat.splice(acceptedFormat.indexOf(".jpeg"), 1)
        : null;
    }

    if (acceptedFormat.includes(".doc")) {
      !acceptedFormat.includes(".docx") ? acceptedFormat.push(".docx") : null;
    } else {
      acceptedFormat.includes(".docx")
        ? acceptedFormat.splice(acceptedFormat.indexOf(".docx"), 1)
        : null;
    }

    if (acceptedFormat.includes(".xls")) {
      !acceptedFormat.includes(".csv") ? acceptedFormat.push(".csv") : null;
      !acceptedFormat.includes(".xlsx") ? acceptedFormat.push(".xlsx") : null;
    } else {
      acceptedFormat.includes(".csv")
        ? acceptedFormat.splice(acceptedFormat.indexOf(".csv"), 1)
        : null;
      acceptedFormat.includes(".xlsx")
        ? acceptedFormat.splice(acceptedFormat.indexOf(".xlsx"), 1)
        : null;
    }

    options.value = acceptedFormat;
  }

  emit("update:options", options.value);
};
</script>
